import dynamic from "next/dynamic";
import Image from "next/image";
import styles from "../styles/Home.module.scss";
import { useState } from "react";
import { useRouter } from "next/router";
import {
  BANNER,
  CATEGORY_SERIES,
  FREE_SERIES,
  FREE_SERIES_V2,
  GROUP_SERIES,
  GROUP_SERIES_2,
  MIXED_ITEMS,
  NEW_SERIES,
  REFER_EARN,
  TOP_SERIES,
} from "../utils/constants";
import { useContext, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import {
  handleCommonSeriesStructData,
  handleDownloadAppEvent,
  handleScrollTo,
  handleWebPageOpenEvent,
} from "../utils/utils";
import { apiGateway } from "../utils/config";
import { Context } from "../store";
import { RouteName } from "../utils/route.utils";
import Cards from "../components/cards/cards";
import Img_newbg from "../public/assets/new-series.webp";
import SwipeableBannerStepper from "../components/swipeBanner/SwipeBanner";
import useStore from "../store/UseStore";
import MobileTopTen from "../components/v3/components/MobileTopTen";
import withUserInformation from "../HOC's/withUserInformation";
import TAGS from "../public/headJson.json";
import Head from "next/head";
import axios from "axios";
import cookie from "cookie";
import OverlayLoader from "../components/v3/components/Common/OverlayLoader";
import MobileCardListing from "../components/v3/components/Common/MobileCardListing";
import Footer from "../components/v3/components/Common/Footer";

// Dynamic imports because these are not required on server side.
const PaymentSuccessModal = dynamic(() =>
  import("../components/premium/premium-utils/PaymentSuccessModal")
);

const BottomPopUp = dynamic(() =>
  import("../components/v3/components/Common/BottomPopUp")
);

const MixedItemsUI = dynamic(() =>
  import("../components/v3/components/MixedItemsUI")
);

const AllMixedItemsSkeletons = dynamic(() =>
  import("../components/Skeleton/AppPage/AllMixedItemSkeleton")
);

const Home = (props) => {
  const { user, setUser, webviewEvent, ssrResponse } = props;
  const globalState = useContext(Context);
  const { glitchLoader, setGlitchLoader } = useStore();
  const router = useRouter();
  const [opacity, setOpacity] = useState(1);
  const [windowSize, setWindowSize] = useState(null);
  const {
    showPaymentSuccess,
    openAllCategories,
    allCategoriesListing,
    allCategoriesLoading,
    isPageRefresh,
    setShowPaymentSuccess,
    setOpenAllCategories,
  } = useStore();
  const firebase_uid = globalState?.user?.uid || user?.uid;
  const freeSeriesV2Ref = useRef(null);
  // useSessionRefresh();

  const breadCrumbStructData = [
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://seekho.in",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Watch Videos",
          item: "https://seekho.in/app",
        },
      ],
    },
  ];

  const handleFilterTop10Series = ssrResponse?.items?.filter((item) => {
    return item?.type === TOP_SERIES;
  });

  const goToSeries = (seriesSlug) => {
    router.push(`/category/${seriesSlug}`);
  };

  const callbackScroll = (scrollWidth, elementRef) => {
    let scW = elementRef?.current.scrollWidth;
    setOpacity((scW - scrollWidth * 2) / scW);
  };

  const typeOFCards = (item, index) => {
    let components = <></>;
    switch (item.type) {
      // This will be visible for Non Premium User
      case FREE_SERIES:
        components = (
          <div>
            <h6
              className="text-white font-semibold text-[17px] text-center md:hidden"
              style={{ fontFamily: "Inter" }}
            >
              {item.title}
            </h6>
            <div
              key={"ITEM" + index + 1}
              className={`${item.type === FREE_SERIES && styles.freeSeries}`}
            >
              <SwipeableBannerStepper
                windowSize={windowSize}
                type={item.type}
                data={item?.free_items_list}
                section_type="trending_section"
              />
            </div>
          </div>
        );
        break;

      // This will be visible only for Premium user
      case BANNER:
        components = (
          <div>
            <h6
              className="text-white font-semibold text-center text-[17px] md:hidden"
              style={{ fontFamily: "Inter" }}
            >
              {item.title}
            </h6>
            <div key={"ITEM" + index + 1} className={`${styles.freeSeries}`}>
              <SwipeableBannerStepper
                windowSize={windowSize}
                type={item.type}
                data={item?.banner_list}
                section_type="trending_series"
              />
            </div>
          </div>
        );
        break;

      case MIXED_ITEMS:
        components = (
          <MixedItemsUI
            data={item?.mixed_items}
            onClickScrollToFreeSeries={() => {
              handleScrollTo({ ref: freeSeriesV2Ref });
            }}
          />
        );
        break;

      case FREE_SERIES_V2:
        components = (
          <div ref={freeSeriesV2Ref} className="relative mt-5 md:hidden">
            <img
              src={`/assets/freeSeriesV2BG.webp`}
              className="w-[100%] md:hidden"
              alt="background"
            />
            <div className="absolute top-36 md:relative md:top-0">
              <div key={"ITEM" + index + 1} className={`${styles.item}`}>
                <h6
                  className="hidden md:block lg:font-semibold md:text-[30px] md:text-white"
                  style={{ fontFamily: "Inter" }}
                >
                  {item.title}
                </h6>
                <Cards
                  type={item.type}
                  callbackScroll={callbackScroll}
                  cardsData={item.free_items_list || item.banner_list}
                  section_type="free_series"
                />
              </div>
            </div>
          </div>
        );
        break;

      case TOP_SERIES:
        components = (
          <div className="text-white mt-4">
            {/* Mobile UI for top 10 listing */}
            <div className="w-[90%] mx-auto md:hidden">
              <h6 className="font-semibold" style={{ fontFamily: "Inter" }}>
                {item.title}
              </h6>
              <MobileTopTen
                cardsData={item?.series_list || item.banner_list}
                type={item?.type}
                section_type="top_10"
              />
            </div>
            {/* Desktop UI for top 10 listing */}
            <div className="hidden md:block">
              <div key={"ITEM" + index + 1} className={`${styles.item}`}>
                <div className={styles.heading}>
                  <div className={styles.title}>{item.title}</div>
                </div>
                <Cards
                  type={item.type}
                  callbackScroll={callbackScroll}
                  cardsData={item.series_list || item.banner_list}
                  section_type="top_10"
                />
              </div>
            </div>
          </div>
        );
        break;

      case CATEGORY_SERIES:
        components = (
          <>
            <div key={"ITEM" + index + 1} className={`${styles.item}`}>
              <div className={styles.heading}>
                <div className="flex gap-x-2">
                  <img
                    src={item?.home_icon}
                    className="w-[40px] md:hidden"
                    alt={item?.title}
                  />
                  <div className={styles.title}>{item.title}</div>
                </div>

                <span
                  className={styles.seeAll}
                  onClick={() => goToSeries(item?.category?.slug)}
                >
                  View All
                  <FontAwesomeIcon
                    className="icon"
                    icon={faChevronRight}
                    style={{ fontSize: 10, marginLeft: 3 }}
                  />
                </span>
              </div>
              <div className="hidden md:block">
                <Cards
                  type={item.type}
                  callbackScroll={callbackScroll}
                  cardsData={item.series_list || item.banner_list}
                  section_type={`${item?.title}`}
                />
              </div>
            </div>

            <div className="w-[90%] mx-auto mt-2 md:hidden">
              <MobileCardListing
                type={item.type}
                cardData={item?.series_list}
              />
            </div>
          </>
        );
        break;
      case GROUP_SERIES_2:
        components = (
          <div key={"ITEM" + index + 1} className={`${styles.item}`}>
            <div className={styles.heading}>
              <div className={styles.title}>{item.title}</div>
              <span
                className={styles.seeAll}
                onClick={() => goToSeries(item?.category?.slug)}
              >
                View All
                <FontAwesomeIcon
                  className="icon"
                  icon={faChevronRight}
                  style={{ fontSize: 10, marginLeft: 3 }}
                />
              </span>
            </div>
            <Cards
              type={item.type}
              callbackScroll={callbackScroll}
              cardsData={item.series_list || item.banner_list}
            />
          </div>
        );
        break;
      case NEW_SERIES:
        components = (
          <div
            key={"ITEM"}
            className={`${styles.item} ${styles.new_series_tab}`}
          >
            <div
              className={styles.img_free_series}
              style={{ opacity: opacity }}
            >
              <Image
                src={Img_newbg}
                loading="lazy"
                alt="new-series"
                title="new-series"
                className={styles.img_free_series_sub}
              />
              <span className={styles.img_free_series_count}>
                {item?.series_list?.length}
              </span>
            </div>
            <Cards
              type={NEW_SERIES}
              callbackScroll={callbackScroll}
              cardsData={item?.series_list}
            />
          </div>
        );
        break;
      case GROUP_SERIES:
        components = (
          <div key={"ITEM" + index + 1} className={`${styles.item}`}>
            <div className={styles.heading}>
              <div className={styles.title}>{item.title}</div>
              <span
                className={styles.seeAll}
                onClick={() => goToSeries(item?.category?.slug)}
              >
                View All
                <FontAwesomeIcon
                  className="icon"
                  icon={faChevronRight}
                  style={{ fontSize: 10, marginLeft: 3 }}
                />
              </span>
            </div>
            <Cards
              type={item.type}
              callbackScroll={callbackScroll}
              cardsData={item.series_list || item.banner_list}
            />
          </div>
        );
        break;
      case REFER_EARN:
        components = (
          <div key={"ITEM" + index + 1} className={`${styles.nomargin}`}>
            <div className={styles.refer_earn_card}>
              <img
                alt="seekho"
                layout="fill"
                src={item?.image}
                className={styles.refer_earn_card_img}
              />
            </div>
          </div>
        );
        break;
      default:
        break;
    }
    return components;
  };

  useEffect(() => {
    if (ssrResponse?.items?.length > 0) {
      setTimeout(() => {
        setGlitchLoader(false);
      }, 100);
    }
  }, [ssrResponse?.items]);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    handleWebPageOpenEvent({
      type: "/app_page",
      firebase_uid,
      webviewEvent,
      campaignDetails: router.query,
    });
  }, [firebase_uid, router.query]);

  useEffect(() => {
    if (isPageRefresh) {
      window.location.reload();
    }
  }, [isPageRefresh]);

  return (
    <>
      <Head>
        {/* Primary Meta Tags */}
        <title>{TAGS.app.title}</title>
        <meta name="title" content={TAGS.app.title} />
        <meta name="description" content={TAGS.app.description} />
        <link rel="canonical" href={RouteName.app} />

        {/* Facebook / OpenGraph */}
        <meta property="og:url" content={RouteName.app} />
        <meta property="og:title" content={TAGS.app.title} />
        <meta property="og:description" content={TAGS.app.description} />
        <meta property="og:image" content={TAGS.landingPage.imageUrl} />
        <meta property="og:image:alt" content="Seekho" />

        {/* Twitter */}
        <meta property="twitter:url" content={RouteName.app} />
        <meta property="twitter:title" content={TAGS.app.title} />
        <meta property="twitter:description" content={TAGS.app.description} />
        <meta property="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@seekhoapp" />
        <meta property="twitter:image" content={TAGS.landingPage.imageUrl} />

        {/* // WebPage Structured Data */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(TAGS.app.webPageStructData),
          }}
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(breadCrumbStructData),
          }}
        />

        {/* Top 10 series */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(
              handleCommonSeriesStructData({
                seriesData: handleFilterTop10Series?.[0]?.series_list,
              })
            ),
          }}
        />
      </Head>

      <div className="App">
        {glitchLoader && <OverlayLoader />}
        <div className={styles.home}>
          {/* h1 Only visible for screen reader's, For SEO purpose */}
          <h1 className="sr-only">{TAGS.app.title.split("-")[1]}</h1>
          {ssrResponse?.items?.map((item, index) => {
            return typeOFCards(item, index);
          })}
          <div style={{ height: 40 }}></div>
        </div>

        <div>
          <Footer />
        </div>

        {showPaymentSuccess && (
          <PaymentSuccessModal
            openModal={showPaymentSuccess}
            setUser={setUser}
            handleCloseModal={() => {
              setShowPaymentSuccess(false);
              handleDownloadAppEvent({
                user: globalState?.user,
                webViewEvent: webviewEvent,
                source_screen: "premium_payment_success",
              });
            }}
          />
        )}

        <BottomPopUp
          isOpen={openAllCategories}
          onClose={() => setOpenAllCategories(false)}
        >
          {allCategoriesLoading ? (
            <div className="max-h-[calc(100vh-200px)] overflow-y-auto">
              <AllMixedItemsSkeletons length={26} />
            </div>
          ) : (
            <div className="max-h-[calc(100vh-200px)] overflow-y-auto">
              <MixedItemsUI data={allCategoriesListing} />
            </div>
          )}
        </BottomPopUp>
      </div>
    </>
  );
};

export const getServerSideProps = async (context) => {
  try {
    const { req } = context;
    const cookies = cookie.parse(req.headers.cookie || "");
    const token = cookies.access_token || cookies.token;
    const accessToken = token ? `jwt ${token}` : "";
    const url = `${apiGateway}/api/v2.1/home/all/?page=1&page_size=50&ssr=true&lang=en`;
    const response = await axios.get(url, {
      headers: {
        Authorization: accessToken,
        "Cache-Control": "no-store",
      },
    });
    return {
      props: {
        ssrResponse: response?.data,
      },
    };
  } catch (error) {
    return {
      notFound: true,
    };
  }
};

export default withUserInformation(Home);
